
import "./DeleteAircraftTypeIntemModal"
export const DeleteAircraftTypeIntemModal = ({aircraftName , capacity, deleteAircraft , onClose}) => {
    const deleteAircraftType = ()=>{
      deleteAircraft()
      onClose()
    }
  return (
    <section className='delete-site-cont'>
    <h3>Are you sure you want to <br /> delete this Aircraft Type?</h3>
    <div className="delete-site-pCont">
        <p>Aircraft Type: <span>{aircraftName}</span></p>
        <p>Capacity: <span>{capacity}</span></p>
    </div>
    <div className='delete-site-btnCont'>
        <button onClick={onClose}>Cancel</button>
        <button onClick={deleteAircraftType}>Ok</button>
    </div>
</section>
  )
}
